import React from 'react';
import { Room } from './Room';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  floorNumber: number;
  rooms: Array<{
    number: string;
    type: 'double' | 'triple' | 'quadruple';
    occupied: number;
    total: number;
  }>;
  isActive: boolean;
};

export const HotelFloor = ({ floorNumber, rooms, isActive }: Props) => {
  const { translations } = useLanguage();

  return (
    <div
      className={`
        relative border border-gray-200 rounded-lg p-4 mb-4
        transform transition-all duration-300
        ${isActive ? 'scale-100 opacity-100 z-10' : 'scale-95 opacity-50'}
      `}
      style={{
        background: `repeating-linear-gradient(
          45deg,
          #f8fafc,
          #f8fafc 10px,
          #f1f5f9 10px,
          #f1f5f9 20px
        )`,
      }}
    >
      {/* Floor Label */}
      <div className="absolute -right-3 -top-3 bg-primary-500 text-white px-3 py-1 rounded-full text-sm">
        {translations?.hotelFloor?.floorLabel || 'Floor'} {floorNumber}
      </div>

      {/* Grid of Rooms */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 mt-4">
        {rooms.map((room) => (
          <div key={room.number} className="aspect-[3/4]">
            <Room key={room.number} {...room} />
          </div>
        ))}
      </div>
    </div>
  );
};